import { createClient } from '@supabase/supabase-js'

// Supabase credentials - Your existing project
const supabaseUrl = 'https://qkebyqcwbcfntruknlrm.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrZWJ5cWN3YmNmbnRydWtubHJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg2MjQ1NzIsImV4cCI6MjA3NDIwMDU3Mn0.x2IgBBmJTVg-wcAFj-ra1hh6cejg843xTn5juH5MWeA'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Storage bucket name
export const STORAGE_BUCKET = 'encrypted-files'
